import { useState } from 'react';
import {
  Button,
  FlexContainer,
  LogoApps,
  useDeviceSize,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import {
  useAuth,
  useFacialAuth,
  useVocalAuth,
  useConfig,
} from '../../providers';
import { RoutesName, userInfoCompletedState } from '../../states';
import { ModalLogout } from '../logout';
import { NoBiometryModal } from '../modals';
import { LanguageSelection } from './LanguageSelection';
import { HeaderStyles } from './Styles';

export const Header = () => {
  const { logout, logged, terms } = useAuth();
  const {
    activeVocal,
    activeFacial,
    noBiometrySelected,
    userName,
    userLastname,
    customPhraseValid,
  } = useConfig();
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
  const [showNoBiometryModal, setShowNoBiometryModal] =
    useState<boolean>(false);
  const userInfoCompleted = useRecoilValue(userInfoCompletedState);
  const { isMobile } = useDeviceSize();
  const { facialValidated } = useFacialAuth();
  const { vocalValidated } = useVocalAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const noUserInfo = !userName || !userLastname;

  const noBiometryActive = !activeVocal && !activeFacial;

  const handleLogout = () => {
    !noUserInfo && setShowLogoutModal(true);
  };

  const handleConfigClick = () => {
    location.pathname !== RoutesName.terms &&
      navigate(RoutesName.configuration);
  };

  const InnerLogo = () => (
    <LogoApps
      logoApp="Authentication"
      size="40"
      color="white"
      labelLines={isMobile ? '2' : '1'}
    />
  );

  return (
    <>
      {logged && terms && userInfoCompleted ? (
        <HeaderStyles
          forwardedAs="header"
          alignItems="center"
          justifyContent="space-between"
        >
          <FlexContainer alignItems="center" columnGap="1.6">
            <Link
              to={
                noUserInfo || noBiometrySelected || !customPhraseValid
                  ? ''
                  : RoutesName.home
              }
              onClick={() => noBiometryActive && setShowNoBiometryModal(true)}
            >
              <InnerLogo />
            </Link>
          </FlexContainer>

          <FlexContainer
            alignItems="center"
            columnGap={!isMobile ? '1.6' : 'unset'}
          >
            {(facialValidated || vocalValidated) && (
              <Button
                color="white"
                variant="text"
                onClick={handleConfigClick}
                testId="private_account_settings_button"
                iconName="Gear"
              >
                {!isMobile && t('Configuration')}
              </Button>
            )}
            <Button
              color="white"
              variant="text"
              onClick={handleLogout}
              testId="logout-button"
              iconName="SignOut"
            >
              {!isMobile && t('Exit')}
            </Button>
            <ModalLogout
              show={showLogoutModal}
              onChangeShow={(showModal) => setShowLogoutModal(showModal)}
              onLogout={logout}
            />
            <NoBiometryModal
              show={showNoBiometryModal}
              onChangeShow={(showModal) => setShowNoBiometryModal(showModal)}
            />
          </FlexContainer>
        </HeaderStyles>
      ) : (
        <LanguageSelection />
      )}
    </>
  );
};
